import { useId, useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

function ContactForm() {
  const [status, setStatus] = useState('');
  const formId = useId();

  const submitForm = (event) => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      event.currentTarget.reportValidity();
      return;
    }

    setStatus(
      'Your details are valid. Connect a submission backend to deliver this inquiry.'
    );
  };

  return (
    <motion.div
      className="contact-form-shell"
      initial={{ opacity: 0, y: 35 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
    >
      <div className="form-topline">
        <span>
          <i aria-hidden="true" />
          Project inquiry
        </span>
        <small>Usually replies within 1 day</small>
      </div>

      <form className="contact-form" onSubmit={submitForm}>
        <div data-greta-form-placeholder="PROJECT_INQUIRY">
          This form is not collecting yet.
        </div>

        <div className="field-row">
          <label htmlFor={`${formId}-name`}>
            Name
            <span className="input-wrap">
              <SafeIcon name="User" aria-hidden="true" focusable="false" />
              <input
                id={`${formId}-name`}
                name="name"
                autoComplete="name"
                required
                placeholder="Your name"
              />
            </span>
          </label>

          <label htmlFor={`${formId}-email`}>
            Email
            <span className="input-wrap">
              <SafeIcon name="Mail" aria-hidden="true" focusable="false" />
              <input
                id={`${formId}-email`}
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="you@company.com"
              />
            </span>
          </label>
        </div>

        <label htmlFor={`${formId}-service`}>
          What can we create together?
          <span className="input-wrap select-wrap">
            <SafeIcon name="Layers" aria-hidden="true" focusable="false" />
            <select id={`${formId}-service`} name="service" defaultValue="" required>
              <option value="" disabled>Select a service</option>
              <option>Real Estate Media</option>
              <option>Audio Recording</option>
              <option>Video Production</option>
              <option>Digital Presence</option>
              <option>A/V Integration</option>
              <option>Graphic Design</option>
              <option>Live Event Production</option>
              <option>Media Duplication</option>
            </select>
          </span>
        </label>

        <label htmlFor={`${formId}-message`}>
          Tell us about your project
          <span className="input-wrap textarea-wrap">
            <SafeIcon name="MessageSquare" aria-hidden="true" focusable="false" />
            <textarea
              id={`${formId}-message`}
              name="message"
              required
              minLength="20"
              rows="5"
              placeholder="Share your vision, goals, timeline, or anything else on your mind..."
            />
          </span>
        </label>

        <div className="form-submit-row">
          <button className="primary-button contact-submit" type="submit">
            <span>Send inquiry</span>
            <span className="submit-icon" aria-hidden="true">
              <SafeIcon name="ArrowUpRight" focusable="false" />
            </span>
          </button>
          <p>
            <SafeIcon name="Lock" aria-hidden="true" focusable="false" />
            Your information stays private.
          </p>
        </div>

        {status && (
          <p className="form-status" role="status" aria-live="polite">
            <SafeIcon name="Info" aria-hidden="true" focusable="false" />
            {status}
          </p>
        )}
      </form>
    </motion.div>
  );
}

export default ContactForm;